import React, {Component} from 'react';
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types';
import {Container, Row, Col, CardGroup, Card, CardBody, Button } from 'reactstrap';

import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { RegisterField } from '../../../views/controls/_FieldValication'
import { logout } from '../../../views/client/actions'
import Messages from '../../../notifications/Messages'
import Errors from '../../../notifications/Errors'
import { validateResetPassword } from '../../../lib/validation'
import EnvConfig from '../../../config/env'

// Import actions
import resetPasswordRequest from './actions';

class ResetPassword extends Component {
  // Pass the correct proptypes in for validation
  static propTypes = {
    handleSubmit: PropTypes.func,
    resetPasswordRequest: PropTypes.func,
    logout: PropTypes.func,
    resetPassword: PropTypes.shape({
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
 
  constructor(props) {
    super(props);
  }

  submit = (values) => {
    values.reset_password_token = this.props.match.params.reset_password_token
    this.props.resetPasswordRequest(values, this.props.history)
  }

  backToLogin = () => {
    this.props.logout();
    this.props.history.push('/login');
  }

  render() {
    const {  
      handleSubmit, // remember, Redux Form injects this into our props
      resetPassword: {
        requesting,
        successful,
        messages,
        errors,
      },
    } = this.props
    
    return (
      <div className="app flex-row align-items-center bg-master ">
        <Container>
          <Row>
            <Col md="12">
            <div className="logo">
              <a href={EnvConfig.HTML_REF}>
                  <img alt="Logo" src="../img/logo.png" />
              </a>
            </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col lg="6" md="8" xs="10">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <BlockUi tag="div" blocking={requesting}>
                    <form className="widget-form" method="post" onSubmit={handleSubmit(this.submit)}>
                    <h1>Active account</h1>
                    <Field icon="icon-lock" type="password" name="new_password" placeholder="Password" component={RegisterField} className="form-control"/>
                    <Field icon="icon-lock" type="password" name="new password_confirm" placeholder="Repeat password" component={RegisterField} className="form-control"/>
                    <Row>
                      <Col md="12">
                        {!requesting && !!errors.length && (
                          <Errors errors={errors} />
                        )}
                        {!requesting && !!messages.length && (
                          <Messages messages={messages} />
                        )}  
                        {!requesting && successful && (
                          <div>
                            <Button onClick={this.backToLogin} color="link" className="px-4" block>Click here to Login »</Button>
                          </div>
                        )}
                      </Col>
                    </Row>
                    <Row style={{'display': (requesting || !successful) ? '' : 'none'}}>
                      <Col xs="6">
                        <Button disabled={!this.props.valid} color="primary" className="px-4" action="submit">Save</Button>
                      </Col>
                    </Row>
                    </form>
                    </BlockUi>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

// Grab only the piece of state we need
const mapStateToProps = state => ({
  resetPassword: state.resetPassword,
})

const connected = connect(mapStateToProps, { resetPasswordRequest, logout })(ResetPassword)

const formed = reduxForm({
  form: 'resetPassword',
  validate: validateResetPassword,
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Pages/ResetPassword/ResetPassword.js